import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-voiceCarrier-lookup',
  templateUrl: './micro-voiceCarrier-lookup.component.html'
})
export class MicroVoiceCarrierLookupComponent  {

  @Input()
  voiceCarrierId:any;
}
